// NPM
import { isNil } from "lodash"
import { Helmet } from "react-helmet"
import { useHistory } from "react-router-dom"
import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

// HOOKS
import useSession from "Hooks/session.hook"

// SERVICES
import { createLine, fetchLine, listLines, updateLine } from "Services/delivery-settings.services"

// HELPERS
import { decode } from "Helpers/enc"
import { toaster } from "Helpers/toaster"

// COMPONENTS
import { StackScreen } from "@life-line-lab/components-react"
import { LineForm } from "Components/delivery-management/delivery-forms"

const DeliveryLinesForm: React.FC<any> = () => {
    const history = useHistory()
    const { org } = useSession()
    const { t } = useTranslation()

    const [response, setResponse] = useState<any>([])
    const [trainLineList, setTrainLineList] = useState<any>([])

    useEffect(()=>{
        handleListLines()
    },[])

    const handleCreateLine = async (data: any) => {
        data.orgID = org._id
        let responseData = await createLine(data)
        if (!isNil(responseData) && responseData.success) {
            toaster("success", t("toaster.createSuccessful"))
            history.push("/delivery-management/settings/lines")
        } else {
            toaster("error", t("toaster.createFailed"))
        }
    }

    const handleUpdateLine = async (data: any) => {
        data.orgID = org._id
        let responseData = await updateLine(data)
        if (!isNil(responseData) && responseData.success) {
            toaster("success", t("toaster.updateSuccessful"))
            history.push("/delivery-management/settings/lines")
        } else {
            toaster("error", t("toaster.updateFailed"))
        }
    }

    const handleFetchLine = async (lineID: string) => {
        const responseData = await fetchLine(decode(lineID) as string)
        if (!isNil(responseData)) {
            setResponse(responseData)
        }
    }

    const handleListLines = async (filters?: any) => {
        const responseData = await listLines()
        if (responseData && !responseData.error) {
            setTrainLineList(responseData)
        }
    }

    const handleCloseStackScreen = () => {
        history.push(`/delivery-management/settings/lines`)
    }

    return (
        <StackScreen
            title={
                <div>
                    <img 
                        alt={t("alt.logo")} 
                        src="/assets/images/banner_logo.png" 
                        height={30} 
                    />
                </div>
            }
            isOpen={true}
            renderHeader={<div></div>}
            onClose={handleCloseStackScreen}
        >
            <Helmet>
                <title></title>
            </Helmet>

            <LineForm 
                onSubmit={handleCreateLine}
                onUpdate={handleUpdateLine}
                onFetch={handleFetchLine}
                trainLineOptions={trainLineList}
                data={response}
            />
        </StackScreen>
    )
}

export default DeliveryLinesForm
